import { SKU_INVALID_CHAR_PATTERN, SKU_INVALID_CHAR_PATTERN_GLOBAL } from '@/constants'

/**
 * SKU character rules.
 *
 * SKUs may contain ONLY `A–Z`, `a–z`, and `0–9`. Everything else — spaces,
 * punctuation, symbols, emoji, accented/non-ASCII letters — is invalid and is
 * hard-rejected at entry (never allowed into the field) and blocks listing.
 *
 * Case is preserved as entered (lowercase is valid); empty is out of scope for
 * this rule — required/optional behaviour is governed elsewhere.
 *
 * Patterns + error strings live in `@/constants` (settings).
 */

// ⛔ TEMPORARILY DISABLED (CDP-2444) — SKU validation is commented out for now.
// Both helpers are neutered so every call site (input hard-reject in
// SkuCellEditor/SimpleInput/InventoryBlock, and the listing block in
// checkAreRequiredFieldsEmpty/ErrorModalBeforeListing) becomes a no-op:
//   • isValidSku always passes  → nothing blocks listing
//   • sanitizeSku is identity    → no characters stripped, no inline error flashed
// To re-enable, restore the original bodies below.
export const isValidSku = (/* value */) => true

export const sanitizeSku = (value) => String(value ?? '')

/* Original implementation — restore to re-enable validation:
export const isValidSku = (value) =>
  value == null || value === '' || !SKU_INVALID_CHAR_PATTERN.test(String(value))

export const sanitizeSku = (value) => String(value ?? '').replace(SKU_INVALID_CHAR_PATTERN_GLOBAL, '')
*/
